import Beep from './Beep.mp3';

/**
 * plays the pop sound when there is new message while window is not focused
 */
export default (() => {
    let mute = false;
    let isSafari = window.safari !== undefined

    return {
        /**
         * play the audio
         */
        play() {
            if(isSafari) return null;
                if(mute) return null;
            

            // let isSafarii = !!navigator.userAgent.match(/Version\/[\d\.]+.*Safari/);
            let isSafarii = !!navigator.userAgent.match(/Version\/[\d]+.*Safari/);
            let iOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
            
            if (isSafarii || iOS) { 
            }else{
                new Audio(Beep).play()
            }
            
            
                    
               
            
        },
        /**
         * mute the sound
         */
        mute() {
            mute = true;
        },
        /**
         * unmute the sound
         */
        unmute() {
            mute = false;
        }
    }
})();



// WEBPACK FOOTER //
// ./src/App/config/notify.js